import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHighcharts from '../CommonComponents/Highcharts';
import LoadingChart from '../CommonComponents/LoadingChart';

class HealthCareChartView extends Component {
  componentDidMount() {
    const { dataIsOutdated, hasLoaded, isPrint } = this.props;

    if ((!hasLoaded || dataIsOutdated) && !isPrint) {
      const { clientId, fpId, getChartData, goalId, isPdf } = this.props;
      getChartData(fpId, clientId, isPdf, goalId);
    }
  }

  render() {
    const { isPrint, chartData, hasLoaded, showLabel, showTitle, chartTitle } = this.props;

    return (
      <section
        className="
        healthCare-chart-component
        chart"
      >
        <div
          className="
          healthcare-chart-container
          NewFinancialPlan_ProgressChart
          NewFinancialPlan_HealthCareProgressChart"
        >
          {showTitle && (
            <h2>
              <span className="title">{chartTitle}</span>
            </h2>
          )}
          {showLabel && (
            <ul className="legend">
              <li>
                <i className="blue" />
                Expenses Covered
              </li>
              <li>
                <i className={`stripe2 ${isPrint ? 'isPrint' : ''}`} />
                Expenses Not Covered
              </li>
            </ul>
          )}
          {!hasLoaded && <LoadingChart />}
          {hasLoaded && (
            <div className="chart_container">
              <ReactHighcharts
                autoResize
                container={isPrint ? 'HealthCareContainer-print' : 'HealthCareContainer'}
                options={chartData}
              />
            </div>
          )}
        </div>
      </section>
    );
  }
}

HealthCareChartView.defaultProps = {
  chartTitle: '',
  isPdf: false,
  isPrint: false,
  showLabel: true,
  showTitle: true,
};

HealthCareChartView.propTypes = {
  chartData: PropTypes.shape({}).isRequired,
  chartTitle: PropTypes.string,
  clientId: PropTypes.string.isRequired,
  dataIsOutdated: PropTypes.bool.isRequired,
  fpId: PropTypes.string.isRequired,
  getChartData: PropTypes.func.isRequired,
  goalId: PropTypes.string.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  isPdf: PropTypes.bool,
  isPrint: PropTypes.bool,
  showLabel: PropTypes.bool,
  showTitle: PropTypes.bool,
};

export default HealthCareChartView;
